<div class="container">
    <div class="row">
        <div class="col-12">
            <button class="btn btn-primary" (click)="addRank()">เพิ่ม RANK</button>
        </div>
        <div class=" col-xl-8 col-12 mt-3">
            <table class="table">
                <thead>
                    <tr>
                        <th [width]="150">รูป (RANK)</th>
                        <th>ระดับ (RANK)</th>
                        <th>ต้องใช้แต้ม</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rank of rankItems">
                        <td><img width="100%" src="{{contentRank}}/{{rank.Rank_image}}" alt=""></td>
                        <td>{{rank.Rank_name}}</td>
                        <td>{{rank.Rank_point}}</td>
                        <td>
                            <button class="btn btn-primary w-100" (click)="viewRank(rank)">แก้ไข</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>


<p-dialog [header]="message" [(visible)]="manageRank" [style]="{width: '50vw'}" (onHide)="clearEvent()">
    <div class="row g-3" [formGroup]="formRank">
        <div class="col-6">
            <app-upload-file (FileUpload)="uploadFile($event)">
                <div class="box-image" *ngIf="!viewImage && !formRank.value['Rank_image']">
                    <p>รูป RANK</p>
                </div>
                <img [src]="viewImage" width="100%" *ngIf="viewImage && addStatus">
                <img [src]="viewImage" width="100%" *ngIf="viewImage  && updateStatus">
                <img src="{{contentRank}}/{{formRank.value['Rank_image']}}" width="100%"
                    *ngIf="!viewImage && formRank.value['Rank_image'] && updateStatus">
            </app-upload-file>
        </div>
        <div class="col-6">
            <p>ชือ RANK</p>
            <input type="text" class="form-control" formControlName="Rank_name">
            <br>
            <p>ต้องคะแนนเอกสิทธิ์เท่าไรถึงอยู่ RANK นี้</p>
            <input type="number" class="form-control" formControlName="Rank_point">
        </div>
        <div class="col-12 text-end mt-3">
            <button class="btn btn-primary me-3" *ngIf="addStatus" (click)="createRank()">
                สร้าง RANK
            </button>
            <button class="btn btn-primary me-3" *ngIf="updateStatus" (click)="updateRank()">
                แก้ไข RANK
            </button>
            <button class="btn btn-cancel" (click)="clearEvent()">
                ปิด
            </button>
        </div>
    </div>
</p-dialog>